// extracted by mini-css-extract-plugin
export var active = "styles-module--active--224f2";
export var blogWrapper = "styles-module--blogWrapper--b26f8";
export var card = "styles-module--card--57e7a";
export var carousel = "styles-module--carousel--c3acd";
export var dot = "styles-module--dot--512d3";
export var dots = "styles-module--dots--72f40";
export var wrapper = "styles-module--wrapper--0e370";